(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-diet"] && !Shopify.designMode) return;
  try {
    (() => {
    const ITEM_SELECTOR = '.product-diet__item';
    const VIEWPORT_MARGIN = 8;
    let hoveredItem = null;

    const itemFrom = (target) => (target instanceof Element ? target.closest(ITEM_SELECTOR) : null);

    // Keeps the tooltip inside the viewport; icons at the start or end of a row would otherwise clip it.
    const positionTooltip = (item) => {
      const tooltip = item.querySelector('.product-diet__tooltip');
      if (!tooltip) return;
      tooltip.style.setProperty('--product-diet-tooltip-shift', '0px');
      const { left, right } = tooltip.getBoundingClientRect();
      const viewportWidth = document.documentElement.clientWidth;
      let shift = 0;
      if (left < VIEWPORT_MARGIN) {
        shift = VIEWPORT_MARGIN - left;
      } else if (right > viewportWidth - VIEWPORT_MARGIN) {
        shift = viewportWidth - VIEWPORT_MARGIN - right;
      }
      tooltip.style.setProperty('--product-diet-tooltip-shift', `${Math.round(shift)}px`);
    };

    document.addEventListener('focusin', (event) => {
      const item = itemFrom(event.target);
      if (item) positionTooltip(item);
    });

    document.addEventListener('focusout', (event) => {
      const item = itemFrom(event.target);
      if (item && !item.contains(event.relatedTarget)) item.removeAttribute('data-tooltip-dismissed');
    });

    document.addEventListener('pointerover', (event) => {
      const item = itemFrom(event.target);
      if (!item || item === hoveredItem) return;
      hoveredItem = item;
      positionTooltip(item);
    });

    document.addEventListener('pointerout', (event) => {
      const item = itemFrom(event.target);
      if (!item || item.contains(event.relatedTarget)) return;
      if (hoveredItem === item) hoveredItem = null;
      if (!item.contains(document.activeElement)) item.removeAttribute('data-tooltip-dismissed');
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      for (const item of [itemFrom(document.activeElement), hoveredItem]) {
        if (item) item.setAttribute('data-tooltip-dismissed', '');
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
